import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck,
  faChevronRight,
  faHandPointRight,
  faAngleDoubleRight
} from '@fortawesome/free-solid-svg-icons'
import {
  BoxBottomLink,
  BoxBottomButtonLink,
  ChevronLinkGap,
  ChevronLinkFocus,
  ChevronGLinkFocus,
  ChevronButtonFocus,
  ChevronLinkFocusBlank,
  ChevronLink,
  // ChevronGLink,
  Cta,
  CtaLink,
  CtaHref,
  CtaButton,
  CtaButtonLink,
  BoxCtaContainer,
  CtaHrefSpecial,
  BoxCtaContainerSpecial
} from 'components/theme/Links'

export const CtaDefault = ({ href, title, children }) => (
  <Cta href={href} target="_blank" title={title}>{children}</Cta>
)

export const ChevronCta = ({ href, children }) => (
  <CtaLink to={href}>
    {children} <span><FontAwesomeIcon icon={faChevronRight} /></span>
  </CtaLink>
)

export const ChevronCtaHref = ({ href, children }) => (
  <CtaHref href={href} target="_blank">{children} <span><FontAwesomeIcon icon={faChevronRight} /></span></CtaHref>
)

export const ChevronCtaHrefSpecial = ({ href, children }) => (
  <CtaHrefSpecial href={href} target="_blank">{children} <span><FontAwesomeIcon icon={faChevronRight} /></span></CtaHrefSpecial>
)

export const CtaDefaultLink = ({ href, children }) => (
  <CtaLink to={href}>
    {children}
  </CtaLink>
)

export const CtaDefaultButton = ({ href, title, className, children, to }) => (
  <React.Fragment>
    {
      to ? (
        <CtaButtonLink className={className} to={to} title={title}>{children}</CtaButtonLink>
      ) : (
          <CtaButton className={className} href={href} target="_blank" title={title}>{children}</CtaButton>
        )
    }
  </React.Fragment>
)

export const CtaDefaultButtonLink = ({ href, className, children }) => (
  <CtaButtonLink to={href} className={className}>
    {children}
  </CtaButtonLink>
)

export const BoxBottom = ({ href, label }) => (
  <BoxBottomLink to={href}>
    {label} <span><FontAwesomeIcon icon={faChevronRight} /></span>
  </BoxBottomLink>
)

export const BoxBottomButton = ({ href, children }) => (
  <BoxBottomButtonLink to={href}>
    {children}
  </BoxBottomButtonLink>
)

export const ChevronDefault = ({ href, label, target, onClick }) => (
  <React.Fragment>
    {
      href ? (
        <React.Fragment>
          {
            typeof target !== 'undefined' ? (
              <ChevronLink href={href} target={target}>
                {label} <i><FontAwesomeIcon icon={faChevronRight} /></i>
              </ChevronLink>
            ) : (
                <ChevronLink href={href}>
                  {label} <i><FontAwesomeIcon icon={faChevronRight} /></i>
                </ChevronLink>
              )
          }
        </React.Fragment>
      ) : (
          <span
            onClick={onClick}
            style={{
              fontFamily: 'roboto',
              fontWeight: 'normal',
              color: '#2a4a77',
              fontSize: '1.8rem',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}>
            {label} <i style={{ paddingLeft: '1rem', fontSize: '1.3rem' }}><FontAwesomeIcon icon={faChevronRight} /></i>
          </span>
        )
    }
  </React.Fragment>
)

export const ChevronSpaced = ({ href, label }) => (
  <ChevronLinkGap to={href}>
    {label} <span><FontAwesomeIcon icon={faAngleDoubleRight} /></span>
  </ChevronLinkGap>
)

export const ChevronFocus = ({ href, children }) => (
  <ChevronLinkFocus
    href={href}
    onClick={(e) => {
      e.preventDefault();
      typeof window !== 'undefined' && window.open(href, "_blank")
    }}>
    <span style={{ display: 'inline' }}><FontAwesomeIcon icon={faHandPointRight} /></span> {children}
  </ChevronLinkFocus>
)

export const GatsbyChevronLinkFocus = ({ to, children }) => (
  <ChevronGLinkFocus to={to}>
    <span style={{ display: 'inline' }}><FontAwesomeIcon icon={faHandPointRight} /></span> {children}
  </ChevronGLinkFocus>
)

export const ChevronFocusHref = ({ href, children }) => (
  <ChevronLinkFocusBlank href={href} target="_blank">
    <span style={{ display: 'inline' }}><FontAwesomeIcon icon={faHandPointRight} /></span> {children}
  </ChevronLinkFocusBlank>
)

export const ChevronButton = ({ to, children }) => (
  <ChevronButtonFocus>
    <span style={{ display: 'inline' }}><FontAwesomeIcon icon={faHandPointRight} /></span> {children}
  </ChevronButtonFocus>
)

export const BulletPointDefault = ({ children }) => (
  <>
    <span><FontAwesomeIcon icon={faCheck} /></span>
    <span>{children}</span>
  </>
)

export const CtaContainer = ({ children }) => (
  <BoxCtaContainer>
    {children}
  </BoxCtaContainer>
)

export const CtaContainerSpecial = ({ children }) => (
  <BoxCtaContainerSpecial>
    {children}
  </BoxCtaContainerSpecial>
)